// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"b8850ab8512ba173a797","452":"39c689d0e76018392dcb","453":"17eff750a4ddde4f3c82","522":"ac1e3eb860c2d4b44a7b","551":"38f618f65469b300b272"}[chunkId] + ".js";
};